import { Instance } from 'mobx-state-tree';
import { UserInviteAcceptedDtoModelBase } from './UserInviteAcceptedDtoModel.base';

/* The TypeScript type of an instance of UserInviteAcceptedDtoModel */
export interface UserInviteAcceptedDtoModelType extends Instance<typeof UserInviteAcceptedDtoModel.Type> {}

/* A graphql query fragment builders for UserInviteAcceptedDtoModel */
export { selectFromUserInviteAcceptedDto, userInviteAcceptedDtoModelPrimitives, UserInviteAcceptedDtoModelSelector } from './UserInviteAcceptedDtoModel.base';

/**
 * UserInviteAcceptedDtoModel
 */
export const UserInviteAcceptedDtoModel = UserInviteAcceptedDtoModelBase
  .actions(self => ({
    // This is an auto-generated example action.
    log() {
      console.log(JSON.stringify(self));
    },
  }));
